export default function organizationpatrimonies(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                organizationpatrimony: action.organizationpatrimony,
            }
        case 'ADD_CURRENT_ORGANIZATION':
          return {
              ...state,
              organizationpatrimony: action.organizationpatrimony,
              organization: action.organization,
          }
        default:
            return state;
    }
}
